import {Component, Input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import {Program, Course} from "../../../../api/models/program.model";

@Component({
    selector: 'app-program-course-section',
    imports: [ReactiveFormsModule],
    templateUrl: './program-course-section.component.html'
})
export class ProgramCourseSectionComponent {
    @Input() group!: FormGroup;
    @Input() programs: Program[] = [];
    @Input() courses: Course[] = [];
}
